<template>
  <div id="bdm_center" :class="isFull === 1 ? 'bdm_center0 top_information1' : ' bdm_center0'">
    <van-nav-bar title="AGC Center" placeholder fixed left-arrow >
        <template #left>
            <img src="../assets/img/bdm/bdm_left.png" alt="" height="20vw" @click="onClickLeft">
        </template>
        <template #right>
            <img src="../assets/img/bdm/bdm_agc_center_log.png" alt="" height="20vw" @click="onClickArticle">
        </template>
    </van-nav-bar>
    <van-row>
        <!--顶部背景-->
        <van-col span="22" offset="1" class="bdm_center_info">
            <van-col span="8"  class="bdm_center_info_join_time">{{ $t('column.join_date') }}: {{ info.join_time }}</van-col>
            <van-col span="14" offset="1" class="bdm_center_info_user_info">
                <van-col span="5" style="text-align: center;"> 
                    <van-image
                    width="30"
                    height="30"
                    round
                    :src="userinfo.head_image"
                    />
                </van-col>
                <van-col span="16">
                    <van-col span="24" class="bdm_center_info_user_name">{{ userinfo.nick_name }}<img :src="info.country_img" v-if="info.country_img"/></van-col>
                    <van-col span="24" class="bdm_center_info_user_id">ID:{{ userinfo.user_id }}</van-col>
                </van-col>
            </van-col>
            <van-col span="7" offset="8" class="bdm_center_info_total3 bdm_center_bg1">
                <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.total_claim') }}</van-col>
                <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.basic_income + info.basic_income }}</van-col>
            </van-col>
             <van-col span="24">
                <van-col span="8" offset="1" class="bdm_center_info_total bdm_center_bg2">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.total_my_commission') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.bonus_income }}</van-col>
                </van-col>
                <van-col span="7" class="bdm_center_info_total bdm_center_bg2">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.this_month') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.month_bonus_income }}</van-col>
                </van-col>
                <van-col span="7" class="bdm_center_info_total bdm_center_bg3">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.last_month') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.last_month_bonus_income }}</van-col>
                </van-col>
             </van-col>
              <van-col span="24">
                <van-col span="8" offset="1" class="bdm_center_info_total bdm_center_bg2">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.total_myself_income') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.basic_income }}</van-col>
                </van-col>
                <van-col span="7" class="bdm_center_info_total bdm_center_bg2">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.this_month') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.month_bonus_income }}</van-col>
                </van-col>
                <van-col span="7" class="bdm_center_info_total bdm_center_bg3">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.last_month') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.last_month_bonus_income }}</van-col>
                </van-col>
             </van-col>
        </van-col>
         <!--切换-->
        <van-col span="24" class="creator_agency_tab1">
            <van-col span="8" offset="1" class="creator_agency_tab_top1">
                <van-cell class="creator_agency_tab_top1_bg" @click="date_show = true" is-link arrow-direction="down">
                    <template #default>
                    <img src="../assets/img/bdm/creator_agency_tab_date.png" class="creator_agency_tab_time"/>
                    <span class="custom-title">{{ creator_date }}</span>
                    </template>
                </van-cell>
            </van-col>
            <van-tabs v-model="creator_active" @click="creator_active_btn">
                 <van-tab disabled></van-tab>
                <van-tab title="CREATOR">
                    
                    <van-col span="22" offset="1" class="creator_agency_commission2">
                    <van-col span="22" offset="1" class="creator_agency_commission_title2"> {{ $t('column.creator_commission')}} </van-col>
                    <van-col span="22" offset="1" class="creator_agency_commission_list2">
                        <van-cell value="History list" @click="jump_href">
                        <template #title>
                            <img src="../assets/img/coin9.png" class="creator_agency_commission_coin2"/>
                            <span class="custom-title">{{ count_bonus_income }}</span>
                        </template>
                        </van-cell>
                    </van-col>
                    </van-col>
                    <van-col span="22" offset="1" class="creator_agency_rate2">
                    <van-col span="22" offset="1" class="creator_agency_rate_time"> {{ progress_info.progress_date }} </van-col>
                    <van-col span="22" offset="1" class="creator_agency_rate_value2"> {{ $t('column.commission_rate')}}: <span>{{ progress_info.progress_ratio }}%</span> </van-col>
                    <van-col span="22" offset="1" class="creator_agency_rate_progress">
                        <van-progress :percentage="progress_sum" color="#FFC003" track-color="#F7F8FB" stroke-width="6" :show-pivot="false"/>
                        <van-col span="24" class="creator_agency_rate_progress_text">
                        <div v-for="(item,i) in progress_list" :key="i" :style="{'width':progress_width}" :class="i === 0 ? 'creator_agency_rate_progress_text_line_left' : 'creator_agency_rate_progress_text_line'">
                            <div class="creator_agency_rate_progress_text_top">{{ item.rate}}</div>
                            <div class="creator_agency_rate_progress_text_bottom"><img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/>{{ item.level_name }}</div>
                        </div>
                        </van-col>
                    </van-col>
                    <van-col span="22" offset="1" class="creator_agency_rate_text2">
                        <van-col span="3"></van-col>
                        <van-col span="20" class="creator_agency_rate_text_centent2">
                        <van-col span="24" class="creator_agency_rate_text_centent_title">
                            {{ $t('column.earnings_in_past_30days')}}: <img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/> {{ progress_info.progress_income }}
                        </van-col>
                        <van-col span="24" class="creator_agency_rate_text_centent_need">
                            {{ $t('column.need')}} <img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/> <span class="creator_agency_rate_text_centent_need_coin">{{ progress_info.progress_balance }}</span> {{ $t('column.to_progress_to_next_level')}} <span>{{ progress_info.progress_next_ratio }}%</span>
                        </van-col>
                        </van-col>
                    </van-col>
                    </van-col>
                    <van-col span="22" offset="1" class="creator_agency_user">
                    <van-col span="10" class="creator_agency_user_left2">
                        <van-cell is-link arrow-direction="down" @click="sexShow=true">
                        <template #default>
                            <span class="custom-title">{{getSexText()}}</span>
                        </template>
                        </van-cell>
                    </van-col>
                    <van-col span="12" offset="2" class="creator_agency_user_right">
                        <van-search
                            v-model="search_user_id"
                            background="unset"
                            @search="search_btn"
                            :placeholder="$t('column.search_user_id')"
                        />
                    </van-col>
                    </van-col>
                    <van-col span="22" offset="1" class="creator_agency_user_list">
                    <van-col span="24" class="creator_agency_user_list_val2" v-for="(item,j) in user_list" :key="j">
                        <van-col span="5" class="creator_agency_user_list_val_avatar">
                        <van-image
                            round
                            width="12vw"
                            height="12vw"
                            :src="item.head_image"
                        />
                        </van-col>
                        <van-col span="18" class="creator_agency_user_list_val_centent">
                            <van-col span="24" class="creator_agency_user_list_val_centent_name2"> 
                                {{ item.nick_name }} <img :src="info.country_img" v-if="info.country_img"/>
                            </van-col>
                            <van-col span="24" class="creator_agency_user_list_val_centent_id"> ID: {{ item.user_id }}</van-col>
                        </van-col>
                        <div class="creator_agency_join_date_background"> {{ $t('column.join_date')}}: {{ item.join_time }} </div>

                        <van-col span="22" offset="1">
                            <van-col span="12" class="creator_agency_user_list_val_commission2">
                                <van-col span="24" class="creator_agency_user_list_val_commission_title2">{{ $t('column.my_commission')}}</van-col>
                                <van-col span="24" class="creator_agency_user_list_val_commission_coin">
                                <img src="../assets/img/coin9.png"/> {{ item.creator_income }}
                                </van-col>
                            </van-col>
                            <van-col span="12" class="creator_agency_user_list_val_commission2">
                                <van-col span="24" class="creator_agency_user_list_val_commission_title2">{{ $t('column.creator_earnings')}}</van-col>
                                <van-col span="24" class="creator_agency_user_list_val_commission_coin">
                                <img src="../assets/img/coin9.png"/> {{ item.basic_income }}
                                </van-col>
                            </van-col>
                        </van-col>
                    </van-col>
                    </van-col>
                </van-tab>
                <van-tab title="MYSELF">
                    <!-- Tab切换按钮 -->
                    <van-col span="22" offset="1" class="myself_tab_buttons">
                      <van-col span="8" class="myself_tab_button" :class="{'myself_tab_active': myself_active_tab === 'daily'}" @click="myself_active_tab_btn('daily')">
                          {{ $t('column.daily_income')}}
                      </van-col>
                      <van-col span="8" offset="1" class="myself_tab_button" :class="{'myself_tab_active': myself_active_tab === 'room'}" @click="myself_active_tab_btn('room')">
                          {{ $t('column.room_data')}}
                      </van-col>
                    </van-col>
                    <!-- 每日数据 -->
                    <van-col span="24" v-if="myself_active_tab === 'daily'">
                      <van-col span="22" offset="1" class="creator_user_daily_income" v-for="(item,i) in daily_income_list" :key="i">
                          <van-col span="22" offset="1" class="creator_user_daily_income_time">
                          <van-cell :title="item.date" is-link  @click="jumpDaily(item.date_ymd)"/>
                          </van-col>
                          <van-col span="22" offset="1" class="creator_user_daily_income_time">
                          <van-col span="8">
                              <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.total')}}</van-col>
                              <van-col span="24" class="creator_user_daily_income_time_coin"> <img src="../assets/img/coin9.png"/>{{ item.total }}</van-col>
                          </van-col>
                          <van-col span="8">
                              <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.basic_income')}}</van-col>
                              <van-col span="24" class="creator_user_daily_income_time_coin2"> <img src="../assets/img/coin9.png"/>{{ item.basic_income }}</van-col>
                          </van-col>
                          <van-col span="8">
                              <van-col span="24" class="creator_user_daily_income_time_name"> {{ $t('column.bonus_ncome')}}</van-col>
                              <van-col span="24" class="creator_user_daily_income_time_coin2"> <img src="../assets/img/coin9.png"/>{{ item.bonus_ncome }}</van-col>
                          </van-col>
                          </van-col>
                      </van-col>
                    </van-col>
                    <!-- 直播数据 -->
                    <van-col span="22" offset="1" class="myself_data_table" v-else>
                    <!-- 表头 -->
                    <van-col span="24" class="myself_table_header">
                        <van-col span="24" class="myself_section_header">
                        <van-col span="12" class="myself_section_title" :class="{'myself_room_tab_active': room_type_tab === 'live'}" @click="room_type_tab = 'live'">{{ $t('column.live_room')}}</van-col>
                        <van-col span="12" class="myself_section_title" :class="{'myself_room_tab_active': room_type_tab === 'chat'}" @click="room_type_tab = 'chat'">{{ $t('column.chat_room')}}</van-col>
                        </van-col>
                        <van-col span="24" class="myself_column_header" v-if="room_type_tab === 'chat'">
                        <van-col span="6" class="myself_column_cell">{{ $t('column.date') }}</van-col>
                        <van-col span="6" class="myself_column_cell">{{ $t('column.mic_duration')}}<br>({{ $t('column.mins')}})</van-col>
                        <van-col span="6" class="myself_column_cell">{{ $t('column.chat_room_gift')}}</van-col>
                        <van-col span="6" class="myself_column_cell">{{ $t('column.chat_room_gift')}}<br>({{$t('column.myself')}})</van-col>
                        </van-col>
                        <van-col span="24" class="myself_column_header" v-else>
                        <van-col span="8" class="myself_column_cell">{{ $t('column.date') }}</van-col>
                        <van-col span="8" class="myself_column_cell">{{ $t('column.mic_duration')}}<br>({{ $t('column.mins')}})</van-col>
                        <van-col span="8" class="myself_column_cell">{{ $t('column.chat_room_gift')}}<br>({{$t('column.myself')}})</van-col>
                        </van-col>
                    </van-col>
                    <!-- 表数据 chat room -->
                    <van-col span="24" class="myself_table_body" v-if=" room_type_tab === 'chat'">
                        <van-col span="24" class="myself_table_row" v-for="(item, index) in chat_data_list" :key="index">
                        <van-col span="6" class="myself_data_cell">{{ item.date }}</van-col>
                        <van-col span="6" class="myself_data_cell">{{ item.duration }}</van-col>
                        <van-col span="6" class="myself_data_cell">
                            <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.chat_income }}
                        </van-col>
                        <van-col span="6" class="myself_data_cell">
                            <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.bonus_income }}
                        </van-col>
                        </van-col>
                    </van-col>
                    <!-- 表数据 live room -->
                    <van-col span="24" class="myself_table_body" v-else>
                        <van-col span="24" class="myself_table_row" v-for="(item, index) in live_data_list" :key="index">
                        <van-col span="8" class="myself_data_cell">{{ item.date }}</van-col>
                        <van-col span="8" class="myself_data_cell">{{ item.duration }}</van-col>
                        <van-col span="8" class="myself_data_cell">
                            <img src="../assets/img/coin9.png" class="myself_coin_icon"/>{{ item.bonus_income }}
                        </van-col>
                        </van-col>
                    </van-col>
                    </van-col>
                </van-tab>
            </van-tabs>
        </van-col>
          <!-- 日期选择器弹窗 -->
        <van-popup v-model="date_show" position="bottom" :style="{ height: '40%',width: '100%' }">
        <van-datetime-picker
            v-model="date_picker"
            :min-date="minDate"
            :max-date="maxDate"
            type="year-month"
            :title="$t('column.select_date')"
            :confirm-button-text="$t('btn.confirm')"
            :cancel-button-text="$t('btn.cancel')"
            @confirm="onMyselfDateConfirm"
            @cancel="date_show = false"
        />
        </van-popup>
        <van-popup v-model="sexShow" position="bottom" :style="{ height: '40%',width: '100%' }">
        <van-picker
            show-toolbar
            :title="$t('column.gender')"
            :columns="genderOptions"
            :confirm-button-text="$t('btn.confirm')"
            :cancel-button-text="$t('btn.cancel')"
            @confirm="onConfirm"
            @cancel="sexShow = false"
        />
        </van-popup>
        <van-overlay :show="loading" z-index="2003">
            <van-loading type="spinner" class="loading_overlay"/>
        </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data:function() {
    return {
      info:{
        month_basic_income: 0,
        month_bonus_income:0,
        last_month_basic_income:0,
        last_month_bonus_income: undefined,
        basic_income:0,
        bonus_income: 0,
        join_time: undefined
      },
      loading: false,
      finished: false,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      creator_date: undefined,
      date_show: false,
      creator_active: 1,
      date_picker: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(new Date().setHours(23,59,59,999)),
      myself_active_tab: 'daily', // 'daily' 或 'room'
      room_type_tab: 'live', // 'live' 或 'chat'
      chat_data_list: [],
      live_data_list: [],
      daily_income_list:[],
      progress_list: [],
      progress_width: '0%',
      progress_ratio: 0,
      progress_sum: 0,
      user_list: [],
      sexShow: false,
      userinfo: {},
      search_user_id: undefined,
      progress_info: {},
      count_bonus_income: 0,
      selectedSex: 0, // 默认选择(0)
      genderOptions: [
        { text:  this.$t('column.sex1_creator'), value: 1 },
        { text:  this.$t('column.sex2_creator'), value: 2 },
        { text: this.$t('column.all_creator'), value: 0 }
      ]
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
     let year = this.date_picker.getFullYear();
    let month = this.date_picker.getMonth() + 1;
    this.creator_date = year + '-' + month
    // this.getList()
    this.getTabList()
    this.agc_center()
  },
  methods: {
    onClickArticle(){
      this.$router.push({ name: 'bdm_article', query: { token: this.$route.query.token, type: 4, is_full: this.isFull } })
    },
    agc_center(){
      const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=agc_center", {
          params : {
              token: token
          }
        }).then(res =>{
          this.info = res.data.data
        })
    },
    claimCoin(item){
      // 领取 claim_task_rewards
      if(item.claim_status == 0){
        this.loading = true
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=claim_task_rewards", {
          params : {
              id: item.id,
              token: token
          }
        }).then(res =>{
          this.loading = false
          Toast(res.data.error)
          this.get_list()
        })
      }
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    getCode() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_verify_code", {
        params : {
            to_user_id: this.inviterId,
            token: token,
            role_type: this.roleType
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
      })
    },
    Jump_intercept(item) {
      // 拦截返回app
      window.location.href="live://live?action=recharge&id="+ item.id
    },
    showAddBtn(type,role_type) {
        this.addType = type
        this.roleType = role_type
        this.inviterId = ''
        this.verificationCode = ''
        this.progress = this.addType === 'admin_add' ? this.admin_number / this.bdm_administrator_restrictions * 100 : this.coin_seller_number / this.bdm_coin_seller_restrictions * 100
        this.popup_title = this.$t('column.' + this.addType)
        this.showAdd = true
    },
    showAddPayrollBtn(){
      this.inviterId = ''
      this.popup_title = this.$t('column.payroll_request')
      this.showPayroll = true
    },
    confirmPayrollAdd(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=apply_settlement", {
        params : {
            to_user_id: this.inviterId,
            token: token,
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showPayroll = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    confirmAdd() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=add_bdm", {
        params : {
            to_user_id: this.inviterId,
            verify_code: this.verificationCode,
            token: token,
            role_type: this.roleType
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showAdd = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=bdm_center",{ params:{token: token }}).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          this.info = res.data.data.info
          this.finished = true
          this.loading = false
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    },


     jumpDaily(date) {
      // 跳转
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/creator_daily_income', query: {uid: uid, token: token, date: date, is_full: this.isFull}})
    },
    jump_href() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/creator_agency_history', query: { uid: uid, token: token, is_full: this.isFull} });
    },
    getSexText() {
      const gender = this.genderOptions.find(item => item.value === this.selectedSex);
      return gender ? gender.text : '';
    },
    onConfirm(value) {
      this.selectedSex = value.value;
      this.sexShow = false;
      this.getTabList()
    },
    getTabList(){
      console.log('getTabList: ' + this.creator_active)
      if(this.creator_active === 2) {
        this.incomelist()
      }else{
        this.getUserList()
        this.getList()
      }
    },
    creator_active_btn() {
      this.getTabList()
    },
    search_btn() {
      this.getTabList()
    },
    myself_active_tab_btn(val){
      this.myself_active_tab = val
      this.getTabList()
    },
    markPosition() {
      const index = this.progress_list.length - 1
      this.progress_width = (100 / index) + '%'
    },
    privateMessage(user_id) {
      // 拦截跳转私信
      window.location.href="live://live?action=JumpUserPrivateMessage&id=" + user_id
    },
    getUserList() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_under_creator",{
        params:{ uid: uid, token: token,search_user_id: this.search_user_id,date:this.creator_date,sex:this.selectedSex}
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.user_list = res.data.data.list
          this.count_bonus_income = res.data.data.count_bonus_income
        }else{
          Toast(res.data.error)
        }
      })
    },
    getList(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_center",{
        params:{ uid: uid, token: token, date: this.creator_date }
      }).then(res =>{
        if(res.data.status===1){
          this.userinfo = res.data.data.user_info
          this.progress_info = res.data.data.progress_info
          this.progress_sum = parseInt(res.data.data.progress_info.progress_sum)
          this.progress_list = res.data.data.progress_list
          this.markPosition()
        }else{
          Toast(res.data.error)
        }
      })
    },
    incomelist() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_center_income",{
        params:{uid: uid, token: token, date: this.creator_date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.daily_income_list = res.data.data.daily_income_list
          this.chat_data_list = res.data.data.room_income_list
          this.live_data_list = res.data.data.live_room_income_list
        }else{
          Toast(res.data.error)
        }
      })
    },
    copyId() {
      const element = document.getElementById("creator_user_id");
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    onClickLeft() {
      // 拦截关闭h5
      this.$router.go(-1);
    },
    // MYSELF tab 相关方法
    onMyselfDateConfirm(value) {
      const year = value.getFullYear()
      const month = String(value.getMonth() + 1).padStart(2, '0')
      this.creator_date = `${year}-${month}`
      this.date_show = false
      // 在这里可以根据日期重新获取数据
      this.getTabList()
    }
  
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/bdm_agc_center.vue